import React from "react";
import './AboutBanner.css';
import miteam from "./assets/banner.jpg";

const AboutBanner = () => {
    return (
        <div className="row">
            <div className="col-12 aboutbanner">
                <img src={miteam} alt="MI Team" className="miteam" />
            </div>
        </div>
    );
};

export default AboutBanner;